import React from 'react';
import PropTypes from 'prop-types';
import WithLazyLoadBreakingNews from 'modules/WithBreakingNews/WithLazyLoadBreakingNews';
import throttle from 'lodash.throttle';
import { inViewForReact } from 'utils/common';
import TopBar from './TopBar/TopBar';
import Navigation from './Navigation/Navigation';
// import Masthead from './Masthead/Masthead';
import NavList from '../../common/NavList/NavList';

class Header extends React.Component {
  constructor() {
    super();
    this.headerContainerRef = React.createRef();
    this.state = {
      stickyHeader: false,
      minHeightHeader: null,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.monitorScroll());
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.monitorScroll());
  }

  monitorScroll = () => throttle(this.handleScrollEvent, 100);

  handleScrollEvent = () => {
    let stickyHeader = false;
    const elem =
      document.getElementById('header-masthead') ||
      document.getElementById('top-bar-container');

    if (elem && !inViewForReact(elem, 0, true)) {
      stickyHeader = true;
    }
    const refreshButton = document.getElementById('refresh-button');
    if (refreshButton && stickyHeader) {
      refreshButton.classList.add('sticky');
    } else if (refreshButton && !stickyHeader) {
      refreshButton.classList.remove('sticky');
    }

    this.setState({ stickyHeader });
    const headerContainerHeight =
      this.headerContainerRef &&
      this.headerContainerRef.current &&
      this.headerContainerRef.current.offsetHeight;

    // Check if the height has changed
    if (headerContainerHeight !== this.state.minHeightHeader) {
      // Update the state with the new height
      this.setState({
        stickyHeader,
        minHeightHeader: headerContainerHeight + 1,
      });
    }
  };

  render() {
    const {
      headerData = {},
      hideCyclicNav,
      showWeatherInC,
      enablePrimeFlow,
    } = this.props;
    const {
      navigation,
      // masthead,
      // videomasthead,
      hideTimeStamp,
      promotionalL2,
    } = headerData;
    // const isMastheadToiLogo = masthead && masthead.type === 'toiLogo';
    const theme = headerData.colorTheme;
    return (
      <div
        className="header-container contentwrapper"
        ref={this.headerContainerRef}
        style={
          this.state.minHeightHeader && {
            'min-height': this.state.minHeightHeader,
          }
        }
      >
        {}
        <TopBar
          isWapView={this.props.isWapView}
          hideTimeStamp={hideTimeStamp}
          editionSwitch={this.props.headerData?.editionSwitch}
          hideTimesPointPopup={this.props.hideTimesPointPopup}
          colorTheme={theme}
          showWeatherInC={showWeatherInC}
          enablePrimeFlow={enablePrimeFlow}
          pageType={this.props.pageType}
        />
        {/* {(masthead || videomasthead) && (
          <Masthead
            config={masthead}
            videomasthead={isPrime ? {} : videomasthead}
            colorTheme={theme}
            earplugAdsRight={headerData.earPlugAdsRight}
            earplugAdsLeft={headerData.earPlugAdsLeft}
            leaderboard={headerData.leaderboard}
          />
        )} */}
        <Navigation
          hideCyclicNav={hideCyclicNav}
          l2navigationChild={this.props.l2navigationChild}
          allMenu={headerData.allMenu}
          colorTheme={theme}
          navigationData={navigation}
          isWapView={this.props.isWapView}
          stickyHeader={this.state.stickyHeader}
          // showHomeOnlyWhenSticky={isMastheadToiLogo}
          pageType={this.props.pageType}
          geolocation={this.props.geolocation}
          isListingEtimesHomePage={this.props.isListingEtimesHomePage}
          pathname={this.props.pathname}
          isPrime={this.props.isPrime}
        />
        {promotionalL2 && (
          <div className="contentwrapper">
            <NavList data={promotionalL2} />
          </div>
        )}
        <WithLazyLoadBreakingNews theme="redTheme" addWrapper withClose />
      </div>
    );
  }
}

// const mapStateToProps = state => ({
//   navigationData: state.header.data,
// });

Header.propTypes = {
  hideCyclicNav: PropTypes.bool,
  l2navigationChild: PropTypes.shape({}),
  promotionalL2: PropTypes.shape({}),
  headerData: PropTypes.shape({
    editionSwitch: PropTypes.shape({}),
  }).isRequired,
  isWapView: PropTypes.bool.isRequired,
  hideTimesPointPopup: PropTypes.bool,
  showWeatherInC: PropTypes.bool,
  enablePrimeFlow: PropTypes.bool,
  pageType: PropTypes.string,
  geolocation: PropTypes.string,
};

Header.defaultProps = {
  hideCyclicNav: false,
  l2navigationChild: null,
  hideTimesPointPopup: false,
  promotionalL2: { items: [] },
  showWeatherInC: false,
  enablePrimeFlow: false,
  pageType: '',
  geolocation: '1',
};

export default Header;
